import type { InputProps } from './Input.types'

export function Input({ label, error, className = '', ...props }: InputProps) {
    return (
        <div className="w-full">
            {label && (
                <label className="block text-sm font-medium text-text-secondary-light dark:text-text-secondary-dark mb-1">
                    {label}
                </label>
            )}
            <input
                className={`w-full px-4 py-3.5 bg-surface-light dark:bg-white/5 border border-border-light dark:border-border-dark rounded-xl text-text-primary-light dark:text-text-primary-dark text-base transition-all duration-200 focus:outline-none focus:border-primary focus:bg-border-light/50 dark:focus:bg-white/10 focus:ring-4 focus:ring-primary/20 ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-500/20' : ''} ${className}`}
                {...props}
            />
            {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
        </div>
    )
}
